/*

  Copyright Webdesign Nord ApS
  Version 1.0.0

*/

if (typeof WDN === "undefined") {
  var WDN = {};
}

if (typeof WDN.Modal === "undefined") {
  WDN.Modal = (function () {
    var List = {};

    var Create;

    var Config = {
      modal: ".Modal",
      modal_content: ".Modal__inner",
      open: ".Modal__open",
      close: ".Modal__close",
      names: {
        body_open: "body--modal-open",
        state: {
          open: "open",
          close: "closed",
        },
      },
    };

    // Factory
    var Modal = function (id) {
      this.id = id;

      this.selectors = {
        body: `body`,
        modal: `${Config.modal}[data-id='${this.id}']`,
        modal_content: `${Config.modal}[data-id='${this.id}'] ${Config.modal_content}`,
        open: `${Config.open}[data-id='${this.id}']`,
        close: `${Config.close}[data-id='${this.id}']`,
      };

      // Cache nodes
      this.nodes = {
        body: document.querySelector(this.selectors.body),
        modal: document.querySelector(this.selectors.modal),
        modal_content: document.querySelector(this.selectors.modal_content),
        open: document.querySelectorAll(this.selectors.open),
        close: document.querySelectorAll(this.selectors.close),
      };

      this.state = {
        open: Config.names.state.open,
        close: Config.names.state.close,
      };

      // Bind named functions
      this.handleEscClick = this.closeOnEsc.bind(this);
      this.handleOutsideClick = this.clickOutside.bind(this);
      this.handleCloseClick = this.close.bind(this);

      // Call to init event listeners
      this.init();
    };

    Modal.prototype.clickOutside = function (event) {
      if (!this.nodes.modal_content.contains(event.target)) {
        this.close();
      }
    };

    Modal.prototype.closeOnEsc = function (event) {
      if (event) {
        if (event.keyCode == "27") {
          this.close();
        }
      }
    };

    Modal.prototype.addEvent = function (item, event, func) {
      return item.addEventListener(event, func.bind(this));
    };

    Modal.prototype.bindInitialEvents = function () {
      // Listen for clicks on elements,
      // thats made for opening the modal
      if (this.nodes.open) {
        this.nodes.open.forEach(function (item) {
          this.addEvent(item, "click", this.open);
        }, this);
      }
    };

    // Bind dynamic events
    Modal.prototype.addDynamicEvents = function () {
      if (this.nodes.close) {
        this.nodes.close.forEach(function (item) {
          item.addEventListener("click", this.handleCloseClick);
        }, this);
      }
      // Listen for ESC
      window.addEventListener("keydown", this.handleEscClick);
      // Listen for clicks outside of modal, to close it
      this.nodes.modal.addEventListener("click", this.handleOutsideClick);
    };

    // Remove dynamic events
    Modal.prototype.removeDynamicEvents = function () {
      if (this.nodes.close) {
        this.nodes.close.forEach(function (item) {
          item.removeEventListener("click", this.handleCloseClick);
        });
      }
      window.removeEventListener("keydown", this.handleEscClick);
      this.nodes.modal.removeEventListener("click", this.handleOutsideClick);
    };

    // Get state of modal
    Modal.prototype._state = function () {
      return this.nodes.modal.dataset.state;
    };

    Modal.prototype.isOpen = function () {
      return this._state() === this.state.open;
    };

    Modal.prototype.isClosed = function () {
      return this._state() === this.state.close;
    };

    // Main actions of modal
    // # Open modal
    Modal.prototype.open = function (event) {
      if (event) {
        event.preventDefault();
      }

      this.addDynamicEvents();
      this.nodes.modal.dataset.state = this.state.open;
      // callbacks
      this.onOpen();
    };

    // # Close modal
    Modal.prototype.close = function (event) {
      if (event) {
        event.preventDefault();
      }

      this.removeDynamicEvents();
      this.nodes.modal.dataset.state = this.state.close;
      this.onClose();
    };

    // # Toggle modal
    Modal.prototype.toggle = function () {
      // If modal is state closed
      if (this.isClosed()) {
        // Open it
        this.open();
      } else {
        // Close it
        this.close();
      }
    };

    // Callbacks
    Modal.prototype.onOpen = function () {
      this.nodes.body.classList.add(Config.names.body_open);
      // Call customly defined callbacks if defined
      if (this.callbacks)
        if (this.callbacks.open) {
          this.callbacks.open.call(this);
        }
    };

    Modal.prototype.onClose = function () {
      this.nodes.body.classList.remove(Config.names.body_open);
      // Call customly defined callbacks if defined
      if (this.callbacks) {
        if (this.callbacks.close) {
          this.callbacks.close.call(this);
        }
      }
    };

    // Bind event listeners on init of new modal
    Modal.prototype.init = function () {
      this.bindInitialEvents();
    };

    Create = function (id) {
      if (
        !List[id] &&
        id &&
        document.querySelector(`${Config.modal}[data-id='${id}']`)
      ) {
        List[id] = new Modal(id);
      } else {
        console.warn(`Failed to init new Modal with ID: "${id}".`);
      }
    };

    // Register all Modals on page
    var Init = function () {
      document.querySelectorAll(`${Config.modal}`).forEach(function (modal) {
        if (modal.dataset.id) {
          Create(modal.dataset.id);
        }
      });
    };

    return {
      List: List,
      Create: Create,
      Init: Init,
    };
  })();
}


WDN.Modal.Init();